module.exports = __webpack_public_path__ + "static/media/oscillators.882e2ffe.png";